import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { content } from './shared/routes/content.route';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { authen } from './shared/routes/auth.route';
import { AuthCallbackComponent } from './features/auth/components/auth-callback/auth-callback.component';
import { LoginGuard } from './features/auth/guards/login.guard';
import { kioskPwaScopeGuard } from './features/kiosk/guards/kiosk-pwa-scope.guard';

export const App_Route: Routes = [
  // Kiosk route is checked first — when the PWA is launched in standalone /
  // fullscreen mode, kioskPwaScopeGuard on every other route bounces back to
  // here so the device stays locked to the kiosk shell.
  {
    path: 'kiosk',
    loadChildren: () =>
      import('./features/kiosk/kiosk.routes').then((m) => m.KIOSK_ROUTES),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full', canMatch: [kioskPwaScopeGuard] },
  {
    path: 'login',
    loadComponent: () =>
      import('../app/features/auth/components/b2c-login/b2c-login.component').then(
        (m) => m.B2cLoginComponent
      ),
    canActivate: [LoginGuard],
    canMatch: [kioskPwaScopeGuard],
  },
  {
    path: 'UserVerify/AssignPwd',
    loadComponent: () =>
      import('../app/features/auth/components/assign-password/assign-password.component').then(
        (m) => m.AssignPasswordComponent
      ),
    canMatch: [kioskPwaScopeGuard],
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
    canActivate: [LoginGuard],
    canMatch: [kioskPwaScopeGuard],
  },
  { path: '', component: MainLayoutComponent, children: content, canMatch: [kioskPwaScopeGuard] },
  { path: '', component: AuthenticationLayoutComponent, children: authen, canMatch: [kioskPwaScopeGuard] },
  { path: '**', redirectTo: '/error/error404', pathMatch: 'full', canMatch: [kioskPwaScopeGuard] },
];
